import React from "react";
import BreadCrumb from "../../Common/BreadCrumb";
import Widgets from "./Widgets";
import TaskActivity from "./TaskActivity";
import LeadsClientActivity from "./LeadsClientActivity";
import TeamConversation from "./TeamConversation";

const ProjectDash = () => {
  return (
    <React.Fragment>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12 xl:col-span-9">
          <BreadCrumb title="Project Dashboard" pageType="Sliced" />
          <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)] mt-4">
            <Widgets />
            <TaskActivity />
            <LeadsClientActivity />
          </div>
        </div>
        <TeamConversation />
      </div>
    </React.Fragment>
  );
};

export default ProjectDash;
